export default class UtilResponseException {

    static print(responseException) {
        const {response = {}} = responseException;
        const {status = -1, data: {data = {}}} = response;
        if(status === 403){
            alert('Нет доступа к данной функции')
        }

        if(status === 400){
            const keys = Object.keys(data);

            const errors = keys.reduce((acc, key) => {
                return [...acc, ...data[key]]
            }, [])

            alert(errors.join('\n'))
        }
    }
}
